<template>
    <div class="nav-warpper">
        <div v-for="(item,index) in nav" :key="index">

            <div v-if="item.leaf">
                <div v-if="item.power.indexOf(user.power) !==-1" :class="{'is-active':item.path === navPath}" class="menu-item">
                    <div @click="navTab(1,index,-1,item.path)">
                        <img :src="item.img" alt="">
                        {{ item.name }}
                    </div>
                    <i :class="{'el-icon-minus':item.state}" class="el-icon-plus" @click="item.state = !item.state"></i>
                </div>
                <el-collapse-transition>
                    <ul v-show="item.state">
                        <li v-for="(child,cindex) in item.child" :key="cindex">
                            <div v-if="child.power.indexOf(user.power) !==-1" :class="{'is-active':child.path === navPath}"
                                 class="menu-item-two">
                                <a v-if="item.id === 36" :href="child.path" target="_blank">{{ child.name }}</a>
                                <div v-else @click="navTab(2,index,cindex,child.path)">{{ child.name }}</div>
                            </div>
                        </li>
                    </ul>
                </el-collapse-transition>
            </div>

            <div v-else>
                <div v-if="item.power.indexOf(user.power) !==-1" :class="{'is-active':item.path === navPath}" class="menu-item">
                    <div @click="navTab(1,index,-1,item.path)">
                        <img :src="item.img" alt="">
                        {{ item.name }}
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "nav-modular",
    data() {
        return {
            nav: [
                {
                    id: 1,
                    name: '首页统计',
                    path: '/home/server-tj',
                    img: require('../assets/img/nav1.png'),
                    child: [],
                    leaf: false,
                    power: [3, 4, 5, 6]
                },
                // {
                //   id: 2,
                //   name: '党的建设',
                //   path: '/home/party-building',
                //   state: false,
                //   img: require('../assets/img/nav2.png'),
                //   child: [
                //     {id: 3, name: '通知公告', path: '/home/notice', child: [], leaf: false, power: [3,4,5, 6]},
                //   ],
                //   leaf: true, power: [3,4,5, 6]
                // },
                // {
                //   id: 4,
                //   name: '综合改造',
                //   path: '/home/synthesize-reform',
                //   state: false,
                //   img: require('../assets/img/nav3.png'),
                //   child: [
                //     {id: 5, name: '民意调查', path: '/home/poll', child: [], leaf: false, power: [3, 4, 5, 6]},
                //     {id: 6, name: '独立民调', path: '/home/merdeka-center', child: [], leaf: false, power: [5,6]},
                //   ],
                //   leaf: true, power: [3, 4, 5, 6]
                // },
                // {
                //   id: 7,
                //   name: '物业管理',
                //   path: '/home/property-management',
                //   state: false,
                //   img: require('../assets/img/nav4.png'),
                //   child: [
                //     {id: 8, name: '物业统计', path: '/home/property-statistics', child: [], leaf: false, power: [3, 4, 5]},
                //     {id: 9, name: '物业合同', path: '/home/property-contract', child: [], leaf: false, power: [5, 6]},
                //     {id: 10, name: '物业情况', path: '/home/property-situation', child: [], leaf: false, power: [3, 4, 5, 6]},
                //     {id: 27, name: '报修情况', path: '/home/property-repair', child: [], leaf: false, power: [ 5, 6]},
                //   ],
                //   leaf: true, power: [3, 4, 5, 6]
                // },
                {
                    id: 11,
                    name: '居民数据',
                    path: '/home/resident-data',
                    state: false,
                    img: require('../assets/img/nav5.png'),
                    child: [
                        // {id: 33, name: '标签管理', path: '/home/label-set', child: [], leaf: false, power: [3, 4, 5]},
                    ],
                    leaf: true, power: [3, 4, 5, 6]
                },
                {
                    id: 12,
                    name: '房屋数据',
                    path: '/home/housing-data',
                    img: require('../assets/img/nav6.png'),
                    child: [],
                    leaf: false, power: [3, 5, 6]
                },
                // {
                //   id: 13,
                //   name: '共享文件',
                //   path: '/home/share-files',
                //   img: require('../assets/img/nav8.png'),
                //   child: [],
                //   leaf: false, power: [5, 6]
                // },
                {
                    id: 20,
                    name: '双暖服务',
                    path: '/home/server-list',
                    img: require('../assets/img/nav5.png'),
                    state: false,
                    child: [
                        {id: 21, name: '服务列表', path: '/home/server-list', child: [], leaf: false, power: [3, 4, 5, 6]},
                        {id: 34, name: '积分设置', path: '/home/calculation', child: [], leaf: false, power: [3]},
                        {id: 48, name: '服务类目设置', path: '/home/server-type', child: [], leaf: false, power: [3]},
                        // {id: 33, name: '服务类目管理', path: '/home/server-category', child: [], leaf: false, power: [3,4,5]},
                        {id: 30, name: '服务对象', path: '/home/server-pople', child: [], leaf: false, power: [3, 4, 5, 6]},
                        {id: 23, name: '申请审核', path: '/home/server-shen', child: [], leaf: false, power: [3, 4, 5, 6]},
                        {id: 35, name: '双暖服务队', path: '/home/team-list', child: [], leaf: false, power: [3, 4, 5]},
                        // {id: 29, name: '志愿者队长', path: '/home/team-admin', child: [], leaf: false, power: [5]},
                        {id: 22, name: '志愿者', path: '/home/team-member', child: [], leaf: false, power: [3, 4, 5, 6]},
                        {id: 31, name: '商品管理', path: '/home/shopping', child: [], leaf: false, power: [3, 4, 5]},
                        // {id: 32, name: '订单管理', path: '/home/order', child: [], leaf: false, power: [5]},

                    ],
                    leaf: true, power: [3, 4, 5, 6]
                },
                // {
                //   id: 41,
                //   name: '双暖学习',
                //   path: '',
                //   img: require('../assets/img/nav5.png'),
                //   state: false,
                //   child: [
                //     {id: 42, name: '学习分类', path: '/home/questions-type', child: [], leaf: false, power: [3,4]},
                //     {id: 46, name: '文章管理', path: '/home/article-list', child: [], leaf: false, power: [3, 4]},
                //     {id: 47, name: '视频管理', path: '/home/video-list', child: [], leaf: false, power: [3, 4]},
                //     {id: 43, name: '试题管理', path: '/home/questions-list', child: [], leaf: false, power: [3, 4]},
                //     {id: 44, name: '竞赛管理', path: '/home/competition-list', child: [], leaf: false, power: [3, 4]},
                //     {id: 45, name: '系统排名', path: '/home/ranking-list', child: [], leaf: false, power: [3, 4]},
                //   ],
                //   leaf: true, power: [3,4]
                // },


                // {
                //   id: 24,
                //   name: '财务管理',
                //   path: '/home/month-finance',
                //   state: false,
                //   img: require('../assets/img/nav8.png'),
                //   child: [
                //     {id: 25, name: '月度收支', path: '/home/month-finance', child: [], leaf: false, power: [5,7]},
                //     {id: 26, name: '财务汇总', path: '/home/year-finance', child: [], leaf: false, power: [5,7]},
                //   ],
                //   leaf: true, power: [5,7]
                // },
                // {
                //   id: 28,
                //   name: '表彰投诉',
                //   path: '/home/commend-complaint',
                //   img: require('../assets/img/nav5.png'),
                //   child: [],
                //   leaf: false, power: [5]
                // },
                {
                    id: 55,
                    name: '预警中心',
                    path: '/home/service-object',
                    img: require('../assets/img/nav6.png'),
                    state: false,
                    child: [
                        {id: 56, name: '服务对象', path: '/home/service-object', child: [], leaf: false, power: [3, 5, 6]},
                        {id: 70, name: '安全守护', path: '/home/safety-dev', child: [], leaf: false, power: [3, 5, 6]},
                        {id: 57, name: '预警设置', path: '/home/alert-settings', child: [], leaf: false, power: [3, 5, 6]},
                        {id: 58, name: '专业人员', path: '/home/professional', child: [], leaf: false, power: [3, 5, 6]},
                        {id: 59, name: '病种管理', path: '/home/disease', child: [], leaf: false, power: [3, 5, 6]},
                        // {id: 60, name: '监测平台', path: '/digitize/monitoring', child: [], leaf: false, power: [5, 6]},
                        {
                            id: 61,
                            name: '健康监测',
                            path: '/digitize/monitoring_watcher',
                            child: [],
                            leaf: false,
                            blank: true,
                            power: [3, 5, 6]
                        },
                        {
                            id: 63,
                            name: '孝亲信息',
                            path: '/digitize/service_info',
                            child: [],
                            leaf: false,
                            blank: true,
                            power: [3, 5, 6]
                        },
                        {id: 66, name: '图片管理', path: '/home/flove_image', child: [], leaf: false, power: [3, 5]},
                        // {id: 64, name: '24小时监测', path: '/digitize/health_info', child: [], leaf: false, power: [5, 6]},
                    ],
                    leaf: true, power: [3, 5, 6]
                },
                {
                    id: 14, name: '系统管理', path: '', state: false, img: require('../assets/img/nav9.png'), child: [
                        {id: 15, name: '账号管理', path: '/home/account', child: [], leaf: false, power: [3, 4, 5]},
                        {id: 16, name: '社区管理', path: '/home/project', child: [], leaf: false, power: [3, 4]},
                        {id: 17, name: '小区管理', path: '/home/community', child: [], leaf: false, power: [3, 4, 5]},
                        {id: 18, name: '个人中心', path: '/home/info', child: [], leaf: false, power: [3, 4, 5, 6]},
                    ], leaf: true, power: [3, 4, 5, 6]
                },
                // {
                //     id: 38,
                //     name: '孝亲信息',
                //     path: '',
                //     img: require('../assets/img/nav6.png'),
                //     state: false,
                //     child: [
                //         {
                //             id: 63,
                //             name: '孝亲信息',
                //             path: '/digitize/service_info',
                //             child: [],
                //             leaf: false,
                //             blank: true,
                //             power: [3]
                //         },
                //         {id: 66, name: '图片管理', path: '/home/flove_image', child: [], leaf: false, power: [3, 4]},
                //     ],
                //     leaf: true, power: [3]
                // },
                {
                    id: 56, name: '公众号管理', path: '', state: false, img: require('../assets/img/nav9.png'), child: [
                        {id: 1, name: '人员管理', path: '/home/gzh/member', child: [], leaf: false, power: [3, 4, 5]},
                        {id: 2, name: '活动管理', path: '/home/gzh/active', child: [], leaf: false, power: [3, 4, 5]},
                        {id: 3, name: '商品管理', path: '/home/gzh/goods', child: [], leaf: false, power: [3, 4, 5]},
                    ], leaf: true, power: [3, 4, 5, 6]
                },
                // {
                //   id: 36, name: '数据统计', path: '', state: false, img: require('../assets/img/nav9.png'), child: [
                //     {id: 41, name: '统计总览', path: '/digitize/all', child: [], leaf: false, power: [3, 4, ]},
                //     {id: 37, name: '服务队建设数据', path: '/digitize/building', child: [], leaf: false, power: [3, 4, ]},
                //     {id: 38, name: '服务队员发展数据', path: '/digitize/team_development', child: [], leaf: false, power: [3, 4]},
                //     {id: 39, name: '服务排名', path: '/digitize/service_rank', child: [], leaf: false, power: [3, 4]},
                //     {id: 40, name: '服务实时数据', path: '/digitize/real_time', child: [], leaf: false, power: [3, 4]},
                //   ], leaf: true, power: [3, 4]
                // },

            ]
        }
    },
    props: {
        navPath: {
            type: String
        }
    },
    created() {
        // this.navPath = this.$route.path
        this.nav.map((item, index) => {
            item.child.map(items => {
                if (items.path === this.navPath) {
                    this.$set(this.nav[index], 'state', true)
                }
            })
        })
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {},
    methods: {
        navTab(type, index, cindex, path) {
            let _path = path ? path : this.nav[index].child[0].path
            if (this.nav[index].id === 14 && this.user.power === 6) {
                _path = '/home/info'
            }
            if (type === 1) {
                this.$router.push(_path)
                if (this.nav[index].leaf) {
                    this.nav.map(item => item.state = false)
                    this.$set(this.nav[index], 'state', !this.nav[index].state)
                }
            } else {
                this.nav.map(item => item.state = false)
                this.$set(this.nav[index], 'state', !this.nav[index].state)
                this.$router.push(_path)
            }
        }
    },
    filters: {},
    watch: {
        navPath() {
            this.nav.map((item, index) => {
                item.child.map(items => {
                    if (items.path === this.navPath) {
                        this.$set(this.nav[index], 'state', true)
                    }
                })
            })

        }
    },
}
</script>

<style lang="scss" scoped>
.nav-warpper {
    position: absolute;
    top: 75px;
    left: 0;
    bottom: 0;
    width: 260px;
    background: #f3b861;
    overflow: auto;

    .menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 55px;
        font-size: 18px;
        color: #fff;
        cursor: pointer;
        border-bottom: 1px solid rgba(255, 255, 255, .1);

        &.is-active {
            background: #f59508;
        }

        div {
            flex: 1;
            padding-left: 30px;
            height: 54px;
            line-height: 54px;

            img {
                width: 18px;
                margin-right: 8px;
            }
        }

        i {
            font-size: 16px;
            color: #fff;
            font-weight: bold;
            margin-right: 30px;
        }

    }

    .menu-item-two {
        display: flex;
        align-items: center;
        height: 55px;
        font-size: 18px;
        color: #fff;
        cursor: pointer;

        &.is-active {
            background: #f59508;
        }

        div {
            flex: 1;
            padding-left: 60px;
            height: 54px;
            line-height: 54px;
        }

        a {
            display: block;
            flex: 1;
            font-size: 18px;
            color: #fff;
            padding-left: 60px;
            height: 54px;
            line-height: 54px;
        }
    }
}
</style>
